import React from 'react';
import { FiltersForm, SidebarFilter } from './FiltersForm';
import styles from './AlertResultsFilters.module.less';

export type AlertResultsFiltersProps = {
  hidden: boolean;
  filters: SidebarFilter;
};

export const AlertResultsFilters: React.FC<AlertResultsFiltersProps> = ({ hidden, filters }) => {
  return (
    <div className={styles.container} hidden={hidden}>
      <FiltersForm filters={filters} />
    </div>
  );
};
